export const genBaseUrl = () => {
  if (window.CUSTOMIZATION_BE !== '__CUSTOMIZATION_BE__') {
    return window.CUSTOMIZATION_BE;
  }

  return 'https://fe-be.whitelabel.dev.portal.apptrium.cloud';
};

export const isSaasBff = () => {
  const url = genBaseUrl();

  return (
    (url.includes('saas') && url.includes('.apptrium.cloud')) || url.includes('/saas-bff-proxy')
  );
};
